/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { countryCodes } from '@/constants/locale';
import { type Locale } from '@/types/i18n';
import { getBaseSchemaUrl } from '@/utils/common';

export const getWebsiteMeta = (locale: Locale) => {
  return JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    url: getBaseSchemaUrl(locale),
    name: locale === countryCodes.mx ? 'AutoZone Mexico' : undefined,
    potentialAction: {
      '@type': 'SearchAction',
      target: getBaseSchemaUrl(locale) + '/searchresult?searchText={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  });
};
